import "../core/ui/constants.js";
import { isUndefined } from "@videojs/utils/predicate";
//#region src/dom/media-action-value.ts
function getMediaInputActionValue(action, key, value) {
	if (!isUndefined(value)) return value;
	const normalizedKey = key?.toLowerCase();
	if (action === "seekStep") return normalizedKey === "arrowleft" || normalizedKey === "j" ? -10 : 10;
	if (action === "volumeStep") return normalizedKey === "arrowdown" ? -.05 : 5 / 100;
}
//#endregion
export { getMediaInputActionValue };

//# sourceMappingURL=media-action-value.js.map